import "rsuite/DateRangePicker/styles/index.css";

import { useEffect, useState } from "react";
import DateRangePicker from "rsuite/DateRangePicker";

import { getExtraction } from "~/services/supervisor.services";
import { cn } from "~/utils/tailwind";

import ExtractionTable from "./table";
import LoadingIcon from "~/components/form/LoadingIcon";

const WorklistComponent = () => {
  const [status, setStatus] = useState<any>({});
  const [activeTab, setActiveTab] = useState<number>(0);
  const [activeData, setActiveData] = useState<string>("");
  const [worklistData, setWorklistData] = useState<any>(null);

  const [range, setRange] = useState<any>([
     new Date(new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000), // Yesterday at midnight
     new Date(new Date()), // Today (current time)
  ]);
  const roleid = localStorage.getItem("roleid");
  const [processrange, setProcessRange] = useState<any>([
     new Date(new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000), // Yesterday at midnight
     new Date(new Date()), // Today (current time)
  ]);
  const handleDateChange = (data: any) => {
    if (data != null && data.length > 0) {
      // Set both dates to midnight
      const startDate = new Date(data[0]);
      const endDate = new Date(data[1]);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      setRange([startDate, endDate]);
      console.log("Date range updated:", startDate, endDate);
    }
  };

  const fetchData = async (fromDate?: Date, toDate?: Date) => {
    let from = new Date();
    let to = new Date();

    // Default to today and tomorrow if no dates provided
    from.setHours(0, 0, 0, 0); // Set to midnight
    to.setHours(0, 0, 0, 0); // Set to midnight

    // If no dates are provided, use today and tomorrow
    if (!fromDate || !toDate) {
      to.setDate(from.getDate() + 1); // Set to tomorrow
    } else {
      from = new Date(fromDate);
      to = new Date(toDate);
    }
    to.setDate(to.getDate() + 1);

    const fromStr = from.toLocaleDateString("en-CA");
    const toStr = to.toLocaleDateString("en-CA");

    const { data, status } = await getExtraction(fromStr, toStr);
    setProcessRange([fromStr, toStr]);
    console.log("Fetched data:", data);
    if (status) {
      setWorklistData((data as any)?.data);

      const allStatus: any = { All: (data as any)?.data };

      setStatus(allStatus);
      const firstKey = Object.keys(allStatus as object)[0] || "";
      setActiveData(firstKey);
      setActiveTab(Object.keys(allStatus as object).indexOf(firstKey));
    } else {
      console.error("Failed to fetch data, status not ok");
    }
  };

  useEffect(() => {
    void fetchData(range[0], range[1]);
  }, [range]);
  useEffect(() => {
    if (range != null) {
      void fetchData(range[0] as Date, range[1] as Date);
    }
  }, [range]);
  return (
    <div className="">
      {worklistData != null ? (
        <>
          <div className="flex justify-between items-center mb-3">
            <h4 className="text-2xl font-semibold text-orange-500">
              {roleid === "16" ? "Test Business Rule" : "Test Extraction"}
            </h4>
            <div className="flex gap-2">
              <div className="text-xl font-semibold">
                <DateRangePicker
                  showOneCalendar
                  format="dd/MM/yyyy"
                  onChange={handleDateChange}
                  value={range}
                />
              </div>
            </div>
          </div>
          <div className="bg-neutral-100 rounded-lg">
            <div className="px-2 flex gap-4 w-full border-b-2 border-b-solid border-b-neutral-200">
              {Object.keys(status as object).length > 0 ? (
                Object.keys(status as object).map((k, index) => (
                  <div
                    key={k}
                    className={cn(
                      "p-3 capitalize font-semibold cursor-pointer",
                      index === activeTab &&
                        "border-b-2 border-b-solid border-b-red-500 text-red-500"
                    )}
                    onClick={() => {
                      setActiveTab(index);
                      setActiveData(k);
                    }}
                  >
                    {k} ({status[k].length})
                  </div>
                ))
              ) : (
                <div className="p-3 font-semibold">
                  <ExtractionTable data={[]} OriginalDateRange={processrange} />
                </div>
              )}
            </div>
            <div className="p-2">
              {Boolean(status) && activeData && Boolean(status[activeData]) && (
                <ExtractionTable
                  data={status[activeData]}
                  OriginalDateRange={processrange}
                />
              )}
            </div>
          </div>
        </>
      ) : (
        <LoadingIcon />
      )}
    </div>
  );
};

export default WorklistComponent;
